import React from 'react'
import {
  Box,
  Button,
  Grid,
} from '@material-ui/core'

import { Batch } from 'src/api/models'
import { useQueryPaginator } from 'src/components/Table'
import {
  FoundHandler,
  FoundItem,
} from 'src/scanRouter/handlers'
import { QuerySelectField } from 'src/forms'
import { skuit } from 'src/services/skuit'

import { ProductCard } from '../ModelCard'
import { BatchDialog } from 'src/modules/supply_chain/components/BatchDialog'

interface FoundItemDisplayProps {
  handler: FoundHandler
  item: FoundItem
}

export const FoundItemDisplay = (props: FoundItemDisplayProps) => {
  const { handler, item } = props
  const selectBatch = handler.batchSelector(item)
  const selectedBatch = item.batch
  const handleSelectBatch = (batch: Batch) => {
      if (selectBatch && selectedBatch?.guid !== batch?.guid) {
        selectBatch(selectedBatch, batch)
      }
  }
  const batchPaginator = useQueryPaginator(
    'batch-list',
    skuit.sc.batches.list,
  )
  return (
    <Grid key={item.key} item container spacing={2} alignItems="center">
      <Grid item xs={10}>
        <ProductCard
          item={item.product.object}
          sku={item.sku?.object}
          selectedCase={item.productCase}
          selectCase={handler.caseSelector(item)}
        >
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">Batch:</Box>
            </Grid>
            <Grid item xs={4}>
              <QuerySelectField
                name="batch"
                label="Batch"
                paginator={batchPaginator}
                onSelected={handleSelectBatch}
                CreateDialog={(props) => {
                  return <BatchDialog {...props} allowSelectASN={false}/>
                }}
                createOnSave={(batch: Batch) => {
                  batchPaginator.refresh()
                  handleSelectBatch(batch)
                }}
              />
            </Grid>
          </Grid>
        </ProductCard>
      </Grid>
      <Grid item xs={2}>
        <Button variant="outlined">{!!item.count && <span>x{item.count}</span>}</Button>
      </Grid>
    </Grid>
  )
}
